import { render, staticRenderFns } from "./responsiveImage.vue?vue&type=template&id=67828937"
import script from "./responsiveImage.vue?vue&type=script&lang=js"
export * from "./responsiveImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Svanehoj-v-13.Website\\src\\Webpack\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67828937')) {
      api.createRecord('67828937', component.options)
    } else {
      api.reload('67828937', component.options)
    }
    module.hot.accept("./responsiveImage.vue?vue&type=template&id=67828937", function () {
      api.rerender('67828937', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/vue/components/responsiveImage.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/scripts/vue/components/responsiveImage.vue
// module id = 41
// module chunks = 0